import { makeStyles } from '@material-ui/core'

export const useStyle = makeStyles((theme) => {
  return {
    container: {
      margin: 'auto',
      background: '#FFFFFF',
      padding: '24px 40px 24px 32px',
      boxShadow: '0px 0px 0px 1px rgba(19,45,74,0.04)',
      borderRadius: 6,
      position: 'relative',
      [theme.breakpoints.down('sm')]: {
        boxShadow: 'none !important',
      },
    },
    strongShadow: {
      boxShadow: '0px 1px 3px rgba(0,0,0,0.12), 0px 0px 0px 1px rgba(19,45,74,0.04)',
    },
  }
})
